var e;!function(e){e.Idle="idle"}(e||(e={}));const n="...",o=20;export{n as ALGOLIA_ELLIPSIS_TEXT,o as ALGOLIA_SNIPPET_MAX_WORDS_COUNT,e as AlgoliaStatusTypeEnum};
